import '../scss/style.scss';

document.addEventListener("DOMContentLoaded", function () {

    const toggleBtn = document.querySelector(".toggle-btn");
    const closeBtn = document.querySelector(".btn-close");
    const mobileNav = document.querySelector(".mobile-nav");

    if(toggleBtn){
        toggleBtn.addEventListener("click", function(){
            mobileNav.classList.add("mobile-nav--active");
        });
    }

    if(closeBtn){
        closeBtn.addEventListener("click", function(){
            mobileNav.classList.remove("mobile-nav--active");
        });
    }

});

document.addEventListener('DOMContentLoaded', function () {
    const mobileMenu = document.getElementById('primary-mobile-menu');

    if (mobileMenu) {
        // Add click event for all parent menu items with submenus
        mobileMenu.querySelectorAll('.menu-item-has-children > a').forEach(function (parentLink) {
            parentLink.addEventListener('click', function (e) {
                e.preventDefault(); // Prevent default anchor behavior

                const parentItem = parentLink.parentElement;
                const subMenu = parentItem.querySelector('.sub-menu');

                if (subMenu) {
                    // Toggle visibility of the submenu
                    subMenu.classList.toggle('sub-menu--active');
                    parentItem.classList.toggle('active');
                }
            });
        });
    }
});


document.addEventListener('DOMContentLoaded', function () {
    // Function to toggle sub-menu visibility
    function toggleSubMenu(event) {
    }

    // Function to hide all sub-menus
    function hideAllSubMenus() {
    }

    // Initially hide all sub-menus
    document.querySelectorAll('.menu-item-has-children > .sub-menu').forEach(subMenu => {
        subMenu.classList.remove('active'); // Remove active class initially
    });

    // Attach click event listener to all menu items with children
    document.querySelectorAll('.menu-item-has-children').forEach(menuItem => {
        menuItem.addEventListener('click', toggleSubMenu);
    });

    // Hide sub-menus when clicking outside
    document.addEventListener('click', function (event) {
        if (!event.target.closest('#primary-menu')) {
            hideAllSubMenus();
        }
    });
});






jQuery(function ($) {

    // Mobile Sticky Pre-Order Button
    $('.sticky-add-to-cart-btn').on('click', function (e) {
        e.preventDefault();

        const $form = $('form.variations_form.cart').first();
        if (!$form.length) return;

        // Check if all attributes are selected
        let allSelected = true;
        $form.find('select[name^="attribute_"]').each(function () {
            if (!$(this).val()) allSelected = false;
        });

        if (!allSelected) {
            // Scroll to variation cards section
            const $target = $('#product-quantity');
            if ($target.length) {
                $('html, body').animate({ scrollTop: $target.offset().top - 100 }, 300);
            }
            return; // stop, wait for user to select
        }

        // Trigger the real WooCommerce Add to Cart
        $form.find('.single_add_to_cart_button').trigger('click');
    });

    // Auto-select default variation card if none selected
    $('.variations_form').each(function () {
        const $form = $(this);

        setTimeout(function () {
            $form.find('.ritual-size__grid').each(function () {
                const $grid = $(this);
                const $select = $form.find(`select[name="${$grid.data('attribute-name')}"]`);

                if ($select.length && !$select.val()) {
                    const $popular = $grid.find('.ritual-size__card[data-popular="1"]:not(:disabled)').first();
                    const $first = $grid.find('.ritual-size__card:not(:disabled)').first();
                    const $target = $popular.length ? $popular : $first;
                    if ($target.length) $target.trigger('click');
                }
            });
        }, 100); // delay to ensure WooCommerce variations load
    });

});


(function () {
    const popupWithSlider = () => {
        let DOM = {};
        let currentIndex = 0;
        let currentImages = [];

        function cacheDOM() {
            DOM.galleries = document.querySelectorAll(".popup-item-wrapper");
            if (!DOM.galleries.length) return;

            // Create popup only once
            const popup = document.createElement("div");
            popup.className = "image-popup";
            popup.innerHTML = `
            <div class="image-popup__inner">
                <div class="popup-close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.127 6.87301C17.2431 6.98909 17.3352 7.1269 17.3981 7.27858C17.4609 7.43026 17.4932 7.59283 17.4932 7.75701C17.4932 7.92119 17.4609 8.08376 17.3981 8.23544C17.3352 8.38712 17.2431 8.52493 17.127 8.64101L13.767 12L17.127 15.359C17.2431 15.4751 17.3352 15.6129 17.398 15.7646C17.4608 15.9163 17.4932 16.0788 17.4932 16.243C17.4932 16.4072 17.4608 16.5697 17.398 16.7214C17.3352 16.8731 17.2431 17.0109 17.127 17.127C17.0109 17.2431 16.8731 17.3352 16.7214 17.398C16.5697 17.4608 16.4072 17.4932 16.243 17.4932C16.0788 17.4932 15.9163 17.4608 15.7646 17.398C15.6129 17.3352 15.4751 17.2431 15.359 17.127L12 13.767L8.641 17.127C8.40655 17.3615 8.08857 17.4932 7.757 17.4932C7.42544 17.4932 7.10745 17.3615 6.873 17.127C6.63855 16.8926 6.50684 16.5746 6.50684 16.243C6.50684 15.9114 6.63855 15.5935 6.873 15.359L10.233 12L6.873 8.64101C6.63855 8.40656 6.50684 8.08857 6.50684 7.75701C6.50684 7.42544 6.63855 7.10746 6.873 6.87301C7.10745 6.63856 7.42544 6.50684 7.757 6.50684C8.08857 6.50684 8.40655 6.63856 8.641 6.87301L12 10.233L15.359 6.87301C15.4751 6.7569 15.6129 6.6648 15.7646 6.60196C15.9162 6.53912 16.0788 6.50677 16.243 6.50677C16.4072 6.50677 16.5698 6.53912 16.7214 6.60196C16.8731 6.6648 17.0109 6.7569 17.127 6.87301Z" fill="white"/>
                    </svg>
                </div>
                <button class="nav-arrow nav-prev" aria-label="Previous image">&#10094;</button>
                <img src="" alt="popup image">
                <button class="nav-arrow nav-next" aria-label="Next image">&#10095;</button>
            </div>
        `;
            document.body.appendChild(popup);

            DOM.popup = popup;
            DOM.popupImg = popup.querySelector("img");
            DOM.prevBtn = popup.querySelector(".nav-prev");
            DOM.nextBtn = popup.querySelector(".nav-next");
            DOM.closeBtn = popup.querySelector(".popup-close");
        }

        function prepareGalleries() {
            DOM.galleries.forEach((gallery) => {
                const images = Array.from(gallery.querySelectorAll("img"));

                images.forEach((img, index) => {
                    if (index > 4) {
                        img.style.display = "none";
                    }
                });

                gallery.dataset.galleryReady = "true";
            });
        }

        function popupToggler(show, images = [], index = 0) {
            if (show) {
                currentImages = images;
                currentIndex = index;
                updatePopup();
                DOM.popup.classList.add("active");
                document.body.style.overflow = "hidden";
            } else {
                DOM.popup.classList.remove("active");
                document.body.style.overflow = "";
            }
        }

        function updatePopup() {
            if (!currentImages.length) return;

            DOM.popupImg.src = currentImages[currentIndex].src;
            DOM.popupImg.alt = currentImages[currentIndex].alt || "";

            DOM.prevBtn.style.display = currentIndex === 0 ? "none" : "block";
            DOM.nextBtn.style.display = currentIndex === currentImages.length - 1 ? "none" : "block";
        }

        function eventListeners() {
            if (!DOM.galleries.length) return;

            DOM.galleries.forEach((gallery) => {
                gallery.addEventListener("click", (e) => {
                    const target = e.target;
                    if (target.tagName.toLowerCase() !== "img") return;

                    const images = Array.from(gallery.querySelectorAll("img"));
                    const visibleImages = images.filter(img => img.src && img.style.display !== "none" || img.style.display === "");

                    const clickedIndex = images.indexOf(target);

                    popupToggler(true, images, clickedIndex);
                });
            });

            DOM.closeBtn.addEventListener("click", (e) => {
                e.stopPropagation();
                popupToggler(false);
            });

            DOM.prevBtn.addEventListener("click", (e) => {
                e.stopPropagation();
                if (currentIndex > 0) {
                    currentIndex--;
                    updatePopup();
                }
            });

            DOM.nextBtn.addEventListener("click", (e) => {
                e.stopPropagation();
                if (currentIndex < currentImages.length - 1) {
                    currentIndex++;
                    updatePopup();
                }
            });

            DOM.popup.addEventListener("click", (e) => {
                if (!e.target.closest("img") && !e.target.closest(".nav-arrow") && !e.target.closest(".popup-close")) {
                    popupToggler(false);
                }
            });

            document.addEventListener("keydown", (e) => {
                if (!DOM.popup.classList.contains("active")) return;

                if (e.key === "Escape") {
                    popupToggler(false);
                } else if (e.key === "ArrowRight" && currentIndex < currentImages.length - 1) {
                    currentIndex++;
                    updatePopup();
                } else if (e.key === "ArrowLeft" && currentIndex > 0) {
                    currentIndex--;
                    updatePopup();
                }
            });
        }

        function init() {
            cacheDOM();
            if (!DOM.galleries || !DOM.galleries.length) return;
            prepareGalleries();
            eventListeners();
        }

        return { init };
    };
    const customAccordion = () => {
        let DOM = {};

        function cacheDOM() {
            DOM.accordions = document.querySelectorAll('.accordion');
        }

        function accordionToggler(header, content, items, allowMultiple = false) {
            const isOpen = header.getAttribute('aria-expanded') === 'true';

            // If only one open at a time
            if (!allowMultiple) {
                items.forEach(item => {
                    const h = item.querySelector('.accordion__header');
                    const c = item.querySelector('.accordion__content');
                    h.setAttribute('aria-expanded', 'false');
                    c.style.maxHeight = null;
                    c.classList.remove('active');
                });
            }

            // Toggle selected
            if (!isOpen) {
                header.setAttribute('aria-expanded', 'true');
                content.style.maxHeight = content.scrollHeight + 30 + 'px';
                content.classList.add('active');
            } else {
                header.setAttribute('aria-expanded', 'false');
                content.style.maxHeight = null;
                content.classList.remove('active');
            }
        }

        // New function to expand or collapse all
        function toggleAll(accordionEl, expand = true) {
            const items = accordionEl.querySelectorAll('.accordion__item');
            items.forEach(item => {
                const header = item.querySelector('.accordion__header');
                const content = item.querySelector('.accordion__content');

                if (expand) {
                    header.setAttribute('aria-expanded', 'true');
                    content.style.maxHeight = content.scrollHeight + 30 + 'px';
                    content.classList.add('active');
                } else {
                    header.setAttribute('aria-expanded', 'false');
                    content.style.maxHeight = null;
                    content.classList.remove('active');
                }
            });
        }

        function setupAccordion(accordionEl) {
            const items = accordionEl.querySelectorAll('.accordion__item');

            // Accordion item click
            items.forEach(item => {
                const header = item.querySelector('.accordion__header');
                const content = item.querySelector('.accordion__content');
                header.addEventListener('click', () =>
                    accordionToggler(header, content, items, true) // set to true for multi-open
                );
            });

            // Expand All toggle (within same accordion container)
            const switchCheckbox = accordionEl
                .closest('.accordion-outside')
                ?.querySelector('.custom-switch-checkbox');

            if (switchCheckbox) {
                switchCheckbox.addEventListener('change', (e) => {
                    const expand = e.target.checked;
                    toggleAll(accordionEl, expand);
                });
            }
        }

        function eventListeners() {
            if (!DOM.accordions.length) return;
            DOM.accordions.forEach(acc => setupAccordion(acc));
        }

        function init() {
            cacheDOM();
            eventListeners();
        }

        return {
            init,
        };
    };
    const tabsToggler = () => {
        let DOM = {};

        function toggleTab(e) {
            const clicked = e.target.closest('.tabs__tab');
            if (!clicked) return;

            const index = clicked.dataset.tab;

            DOM.tabs.forEach(tab => tab.classList.remove('tabs__tab--active'));
            DOM.panels.forEach(panel => panel.classList.remove('tabs__panel--active'));

            clicked.classList.add('tabs__tab--active');
            DOM.panels[index].classList.add('tabs__panel--active');
        }

        function eventListeners() {
            DOM.tabs.forEach(tab => {
                tab.addEventListener('click', toggleTab);
            });
        }

        function cacheDOM() {
            const container = document.querySelector('[data-tabs]');
            if (!container) return;

            DOM.container = container;
            DOM.tabs = container.querySelectorAll('.tabs__tab');
            DOM.panels = container.querySelectorAll('.tabs__panel');
        }

        function init() {
            cacheDOM();
            if (!DOM.container) return;
            eventListeners();
        }

        return { init };
    };

    // Initialize when DOM is ready
    document.addEventListener("DOMContentLoaded", function () {
        popupWithSlider().init();
        customAccordion().init();
        tabsToggler().init();
    });
})();

document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('qty-btn')) return;

    const wrapper = e.target.closest('.quantity');
    const input = wrapper.querySelector('input.qty');

    let value = parseInt(input.value) || 0;
    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || Infinity;
    const step = parseInt(input.step) || 1;

    if (e.target.classList.contains('qty-btn--plus')) {
        if (value < max) input.value = value + step;
    }

    if (e.target.classList.contains('qty-btn--minus')) {
        if (value > min) input.value = value - step;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
});

jQuery(document).ready(function ($) {

    $('.htc__wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        infinite: false,
        adaptiveHeight: true,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

});
